import { Button, Col, Form, Input, Row } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { Success } from "../../../commons/Messages/Messages";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { useTranslation } from "react-i18next";

const UpdatePassword = () => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async ({ oldPassword, password }) => {
    setLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/users/change-password`,
        { oldPassword, password },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      Success(t("Password updated successfully!"));
      form.resetFields();
    } catch (err) {
      generalErrorAlert(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form
        size="large"
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 400 }}
      >
        <Row gutter={[10, 0]}>
          <Col xs={24} md={24}>
            <Form.Item
              label={t("Old Password")}
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: t("enter", { field: t("Old Password") })
                }
              ]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              label={t("New Password")}
              name="password"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: t("enter", { field: t("New Password") })
                },
                { min: 8, message: t("The new password must be at least 8 characters long.") },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("oldPassword") !== value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(t("The new password must differ from the old one."))
                    );
                  }
                })
              ]}
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              name="confirm"
              label={t("Confirm Password")}
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: t("enter", { field: t("Confirm Password") })
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("passwordsDntMatch")));
                  }
                })
              ]}
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item>
              <Button loading={loading} className="w-100 mt-4" type="primary" htmlType="submit">
                {t("Submit")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UpdatePassword;
